function postLink(t, e) {
  var n = (e = e || {}).method || "post",
    i = e.parameters || {},
    o = document.createElement("form");
  for (var r in (o.setAttribute("method", n), o.setAttribute("action", t), i)) {
    var l = document.createElement("input");
    l.setAttribute("type", "hidden"),
      l.setAttribute("name", r),
      l.setAttribute("value", i[r]),
      o.appendChild(l);
  }
  document.body.appendChild(o), o.submit(), document.body.removeChild(o);
}

const CustomerAddress = {
  toggleForm: function (e) {
    var t = document.getElementById("edit_address_" + e),
      s = document.getElementById("view_address_" + e);
    return (
      (t.style.display = "none" == t.style.display ? "" : "none"),
      (s.style.display = "none" == s.style.display ? "" : "none"),
      !1
    );
  },
  toggleNewForm: function () {
    var e = document.getElementById("add_address");
    const no_address_ui = document.querySelector(".no-address-ui");

    const address_count = e.getAttribute("data-address-count");
    if (address_count && address_count == 0) {
      (no_address_ui.style.display =
        "none" == no_address_ui.style.display ? "" : "none"),
        !1;
    }

    return (e.style.display = "none" == e.style.display ? "" : "none"), !1;
  },
  destroy: function (e, t) {
    confirm(t || "Are you sure you wish to delete this address?") &&
      postLink("/account/addresses/" + e, {
        parameters: {
          _method: "delete",
        },
      });
  },
};

document.addEventListener("DOMContentLoaded", () => {
  const add_new_address_btn = document.querySelectorAll(".add-new-address");
  const cancel_add_address = document.querySelector(".cancel-add-address");
  const cancel_update_address = document.querySelectorAll(
    ".cancel-update-address"
  );
  const edit_address = document.querySelectorAll(".edit-address");
  const delete_address = document.querySelectorAll(".delete-address");

  if (edit_address && edit_address.length > 0) {
    edit_address.forEach((btn) =>
      btn.addEventListener("click", () => {
        const id = btn.getAttribute("data-address-id");
        CustomerAddress.toggleForm(id);
      })
    );
  }

  if (delete_address) {
    delete_address.forEach((btn) => {
      btn.addEventListener("click", () => {
        const id = btn.getAttribute("data-address-id");
        CustomerAddress.destroy(id);
      });
    });
  }

  if (add_new_address_btn) {
    add_new_address_btn.forEach((btn) => {
      btn.addEventListener("click", () => {
        CustomerAddress.toggleNewForm();
      });
    });
  }

  if (cancel_add_address) {
    cancel_add_address.addEventListener("click", () => {
      CustomerAddress.toggleNewForm();
    });
  }

  if (cancel_update_address) {
    cancel_update_address.forEach((btn) => {
      btn.addEventListener("click", () => {
        const id = btn.getAttribute("data-form-id");
        CustomerAddress.toggleForm(id);
      });
    });
  }
});
